module.exports = __webpack_public_path__ + "img/default-merchant-image.54e9e85a.svg";